<template>
  <NavBurgerMenuUniverse :id="item.id" :image="item.image" :title="item.title">
    <NavBurgerMenuHeader
      :color="item.color"
      :title="item.title"
      @back="clearActiveMenu"
      @close="$emit('click-item')"
    />
    <NavBurgerMenuCategoryDetail
      :category="item"
      @click-item="$emit('click-item')"
    />
  </NavBurgerMenuUniverse>
</template>

<script setup lang="ts">
import { useActiveMenu } from '../../composables/useActiveMenu'
import type { NavigationItem } from '../../types'

import NavBurgerMenuCategoryDetail from './NavBurgerMenuCategoryDetail.vue'
import NavBurgerMenuHeader from './NavBurgerMenuHeader.vue'
import NavBurgerMenuUniverse from './NavBurgerMenuUniverse.vue'

defineProps<{
  item: NavigationItem
}>()

defineEmits<{
  'click-item': []
}>()

const { clearActiveMenu } = useActiveMenu()
</script>
